var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-list-group",
    [
      _c(
        "b-list-group-item",
        [
          _c("router-link", { attrs: { to: { name: "SupervisorIndex" } } }, [
            _vm._v("Clientes por marcas autorizadas")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-list-group-item",
        [
          _c("router-link", { attrs: { to: { name: "SupervisorOffices" } } }, [
            _vm._v("Oficinas de marcas autorizadas")
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52965ec6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52965ec6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Supervisor/Menu.vue
// module id = null
// module chunks = 